import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=3eeae654&"
import script from "./Shell.vue?vue&type=script&lang=ts&"
export * from "./Shell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eeae654')) {
      api.createRecord('3eeae654', component.options)
    } else {
      api.reload('3eeae654', component.options)
    }
    module.hot.accept("./Shell.vue?vue&type=template&id=3eeae654&", function () {
      api.rerender('3eeae654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standalone/Shell.vue"
export default component.exports